/**
 * Remove duplicates from an array
 *
 * @param data The array to remove duplicates from
 * @returns The array with duplicates removed
 */
export function dedupe(data) {
    return [...new Set(data)];
}
export var Direction;
(function (Direction) {
    Direction[Direction["Left"] = 0] = "Left";
    Direction[Direction["Right"] = 1] = "Right";
})(Direction || (Direction = {}));
/**
 * Get the next index or previous index in array, looping around if necessary.
 *
 * @param currentIndex The current index.
 * @param direction The direction to move in.
 * @param items The array of items.
 * @returns The next index.
 */
export function getLoopedIndex(currentIndex, direction, items) {
    const length = Array.isArray(items) ? items.length : items;
    if (direction === Direction.Left) {
        return currentIndex - 1 < 0 ? length - 1 : currentIndex - 1;
    }
    else {
        return currentIndex + 2 > length ? 0 : currentIndex + 1;
    }
}
